// Announcements sub navigation expander
$('.category-sidebar i').on('click', function() {
    $(this).parent().parent().toggleClass('expanded-section-nav');
    $('.category-sidebar li').toggleClass('visible-nav-items');
    $(this).toggleClass('expanded-section-icon');
});
